import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const serviceTypesService = {
    getAll: async () => {
        try {
            const res = await axiosService.get(endPoints.serviceTypes.base);

            return res;
        } catch (error) {
            throw error;
        }
    }
}

export {
    serviceTypesService
}
